import { Container } from '@cgs/wge';
import { IconsSceneObject } from '../../reels_engine/icons_scene_object';
import { T_IReelsConfigProvider, RESOURCES_COMPONENT_TOKEN } from '../../type_definitions';
import { IReelsConfigProvider } from './interfaces/i_reels_config_provider';
import { ResourcesComponent } from './resources_component';

export class IconsSceneObjectComponent {
  public iconsRender: IconsSceneObject;
  public animIconsRender: IconsSceneObject;

  constructor(container: Container, drawWithPushState: boolean = true) {
    console.log('load ' + this.constructor.name);
    const reelsConfig = container.resolve<IReelsConfigProvider>(T_IReelsConfigProvider).reelsConfig;
    const res = container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN);
    this.iconsRender = new IconsSceneObject(drawWithPushState, container, reelsConfig);
    this.animIconsRender = new IconsSceneObject(drawWithPushState, container, reelsConfig);
    const iconsHolder = res.slot.findById('icons_holder');
    const animHolder = res.slot.findById('anim_icons_holder');
    const iconFrameStart = res.findStartReelNode(0);
    this.iconsRender.position = iconFrameStart.position;
    this.animIconsRender.position = iconFrameStart.position;

    if (iconsHolder) {
      iconsHolder.addChild(this.iconsRender);
    }
    if (animHolder) {
      animHolder.addChild(this.animIconsRender);
    }
  }
}
